document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(toggle&&nav){
    const closeMenu=()=>{toggle.setAttribute('aria-expanded','false');nav.hidden=true;document.body.classList.remove('menu-open')};
    const openMenu=()=>{toggle.setAttribute('aria-expanded','true');nav.hidden=false;document.body.classList.add('menu-open');nav.querySelector('a,button')?.focus()};
    toggle.addEventListener('click',()=>{toggle.getAttribute('aria-expanded')==='true'?closeMenu():openMenu()});
    nav.addEventListener('click',event=>{if(event.target.closest('a'))closeMenu()});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true'){closeMenu();toggle.focus()}});
    window.addEventListener('resize',()=>{if(window.innerWidth>900)closeMenu()});
  }
});
